module.exports = __webpack_public_path__ + "img/picture8.4fc14389.png";